/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Prompt_VersioningInputs */

const en_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt versioning`)
};

const ar_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إصدار الأوامر`)
};

const bn_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`প্রম্পট ভার্সনিং`)
};

const de_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prompt-Versionierung`)
};

const es_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solicitar versionado`)
};

const fr_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versionnement rapide`)
};

const pt_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Controle de versão de prompt`)
};

const zh_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提示版本控制`)
};

const tr_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İstemi sürüm oluşturma`)
};

const ru_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Подскажите версию`)
};

const pl_svchip_prompt_versioning = /** @type {(inputs: Svchip_Prompt_VersioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Szybkie wersjonowanie`)
};

/**
* | output |
* | --- |
* | "Prompt versioning" |
*
* @param {Svchip_Prompt_VersioningInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_prompt_versioning = /** @type {((inputs?: Svchip_Prompt_VersioningInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Prompt_VersioningInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_prompt_versioning(inputs)
	if (locale === "bn") return bn_svchip_prompt_versioning(inputs)
	if (locale === "de") return de_svchip_prompt_versioning(inputs)
	if (locale === "es") return es_svchip_prompt_versioning(inputs)
	if (locale === "fr") return fr_svchip_prompt_versioning(inputs)
	if (locale === "pt") return pt_svchip_prompt_versioning(inputs)
	if (locale === "zh") return zh_svchip_prompt_versioning(inputs)
	if (locale === "tr") return tr_svchip_prompt_versioning(inputs)
	if (locale === "ru") return ru_svchip_prompt_versioning(inputs)
	if (locale === "pl") return pl_svchip_prompt_versioning(inputs)
	return en_svchip_prompt_versioning(inputs)
});